export type DisputeType = "DISPUTE" | "NO_DISPUTE";
export type DisputeStatus = "DISPUTE_RAISED" | "NO_DISPUTE" | "RESOLUTION_PENDING" | "RESOLVED";

export const DISPUTE_HISTORY_TYPES = {
  DISPUTE: "DISPUTE_REASON",
  NO_DISPUTE: "NO_DISPUTE_DETAILS",
  RESOLUTION_REQUEST: "RESOLUTION_PENDING_DETAILS",
  RESOLUTION_ACCEPTED: "RESOLVED_REASON",
  RESOLUTION_REJECTED: "REJECTION_REASON",
} as const;

export interface DisputeDocument {
  id?: string;
  url: string;
  originalFileName: string;
}

// Kept as a compatibility alias for the existing No-Dispute form types.
export type NoDisputeDocument = DisputeDocument;

export interface DisputeHistoryEntry {
  type: string;
  createdBy: string;
  createdByRole: string;
  createdAt: string;
  disputeDetails: string;
  documents: DisputeDocument[];
}

export interface DisputeRecord {
  id: string;
  vesselCallId: string;
  disputeRequestNumber: number;
  status: DisputeStatus;
  terminal: string;
  createdBy: string;
  createdByRole: string;
  createdAt: string;
  disputeDetails: string;
  documents: DisputeDocument[];
  history: DisputeHistoryEntry[];
  associatedMovementId?: string;
  associatedMovement?: string;
}

export interface EligibleAssociatedMovement {
  id: string;
  orderId: number;
  from: string;
  to: string;
  displayName: string;
}

// Shared dispute response returned by both search and details endpoints.
export type Dispute = DisputeRecord;
export type DisputeDetails = DisputeRecord;

export interface DisputesResponse {
  items: Dispute[];
  pageNumber: number;
  pageSize: number;
  totalElements: number;
  totalPages: number;
}

export interface DisputeFilterRequest {
  vesselCallId: string;
  disputeRequestNumbers?: number[];
  terminal?: string[];
  disputeDetails?: string[];
  createdBy?: string[];
  createdAt?: [string | null, string | null][];
  status?: string[];
}

export interface CreateDisputePayload {
  vesselCallId: string;
  associatedMovementId: string;
  type: DisputeType;
  disputeDetails: string;
  documents: DisputeDocument[];
}

export type DisputeUpdateAction = "NO_DISPUTE" | "ACCEPT" | "REJECT" | null;

export interface UpdateDisputePayload {
  action: DisputeUpdateAction;
  disputeDetails: string;
  documents: DisputeDocument[];
}

export type ResolveDisputePayload = UpdateDisputePayload;

export type ReviewDisputeResolutionPayload = Omit<UpdateDisputePayload, "action"> & {
  action: "ACCEPT" | "REJECT";
};
